
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_1dt78_5",
  "header": "awsui_header_l0dv0_1dt78_18",
  "header-link": "awsui_header-link_l0dv0_1dt78_23",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1dt78_31",
  "header-link-text": "awsui_header-link-text_l0dv0_1dt78_31",
  "header-logo": "awsui_header-logo_l0dv0_1dt78_35",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1dt78_41",
  "list-container": "awsui_list-container_l0dv0_1dt78_46",
  "list": "awsui_list_l0dv0_1dt78_46",
  "list-variant-root": "awsui_list-variant-root_l0dv0_1dt78_56",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1dt78_62",
  "list-item": "awsui_list-item_l0dv0_1dt78_66",
  "section": "awsui_section_l0dv0_1dt78_72",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_1dt78_73",
  "section-header": "awsui_section-header_l0dv0_1dt78_86",
  "link": "awsui_link_l0dv0_1dt78_91",
  "link-active": "awsui_link-active_l0dv0_1dt78_98",
  "info": "awsui_info_l0dv0_1dt78_130",
  "external-icon": "awsui_external-icon_l0dv0_1dt78_134",
  "divider": "awsui_divider_l0dv0_1dt78_138",
  "divider-default": "awsui_divider-default_l0dv0_1dt78_143",
  "divider-header": "awsui_divider-header_l0dv0_1dt78_147"
};
  